module.exports = __webpack_public_path__ + "static/react-themes-dimension-ad05214991e38b09448282cfebfbbeb0.jpg";